module.exports = ".group {\n  margin-bottom: 15px;\n  margin-left: 0;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e5e5e5; }\n  .group .form-group {\n    margin-bottom: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    border-bottom: none; }\n  :host /deep/ .form-group {\n  padding-top: 0;\n  padding-bottom: 0;\n  border-bottom: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/form-category/form-category.component.scss
// module id = ./src/app/shared/form-category/form-category.component.scss
// module chunks = main